module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AboutRaz","short_name":"AboutRaz","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/assets/images/website-icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-firebase/gatsby-browser.js'),
      options: {"plugins":[],"features":{"auth":false,"database":false,"firestore":false,"storage":false,"messaging":false,"functions":false,"performance":false,"analytics":true},"credentials":{"apiKey":"AIzaSyAxVVjUbV1-qtkIS7N46UkCgkvAS23-UZ4","authDomain":"aboutraz.firebaseapp.com","databaseURL":"https://aboutraz.firebaseio.com","projectId":"aboutraz","storageBucket":"aboutraz.appspot.com","messagingSenderId":"800528552573","appId":"1:800528552573:web:b9af58131ffb563f4f9714","measurementId":"G-LJFM2BNC87"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
